export default __webpack_public_path__ + "static/media/Damaso_No12Close.d46e4b3c.jpg";